export default {
	terms: "Conditions générales",
	and: "Et",
	actions: {
		Submit: "Soumettre",
		BackToLogin: "Retour à la connexion",
		Register: "S'inscrire",
		Logout: "Se déconnecter",
		Update: "Mettre à jour",
		Verify: "Verificar",
		connect: "Se connecter",
		Taptochange: "Appuyez pour changer"
	},
	rules: {
		isRequired: "Requis",
		require: "{0} est requis",
		valid: "{0} n'est pas un(e) {0} valide",
		cannotContainBlankStrings: "{0} ne peut pas contenir de chaînes vides"
	},
	options: {
		gender: ["Homme", "Femme"]
	}
};
